<template>
    <div class="notification" ref="notification" v-show="showNotification">
        <div class="notification__content -wrap">
            <span class="icon-notice"></span>
            <span class="notification__text" v-html="notification"></span>
            <span @click="hideNotification" class="icon-cancel"></span>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        name: 'notification',
        computed: {
            ...mapGetters({
                showNotification: 'isNotificationVisible',
                notification: 'getCurrentNotification'
            }),
        },
        methods: {
            ...mapActions({ hideNotification: 'hideNotification' }),
            assignNotificationHeight () {
                setTimeout(() => {
                    this.$store.dispatch('setNotificationHeight', this.$refs.notification.clientHeight)
                }, 100)
            }
        },
        watch: {
            notification: function (newState, oldState) {
                if (newState !== '' && newState !== undefined) {
                    this.assignNotificationHeight()
                }
            }
        },
        mounted () {
            if (this.showNotification && this.notification !== '' && this.notification !== undefined) {
                this.assignNotificationHeight()
            }
        }
    }
</script>

<style lang="scss" scoped>
.notification {
    font-family: Nunito-Regular, sans-serif;
    font-size: 1.8rem;
    background: $mandys_pink;
    color: $black;
    overflow: hidden;
    z-index: 999;
    position: fixed;
    padding: 15px 0;
    top: 85px;
    left: 20px;
    right: 20px;

    [class*="desktop"] & {
        top: 0;
        left: 0;
        right: 0;
    }

    &__content {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        gap: 10px;
    }

    .icon-notice {
        font-size: 2.6rem;
        color: $chestnut;

        &:before {
            cursor: default;
        }
    }

    .icon-cancel {
        font-size: 2.2rem;
        margin-left: auto;
    }
}
</style>
